import type { TimelineLookupStructure } from './epoch-size-select.types';

export const timelineLookup: TimelineLookupStructure[] = [
  { label: '30 s', inSeconds: 30 },
  { label: '60 s', inSeconds: 60 },
  { label: '2 min', inSeconds: 120 },
  { label: '5 min', inSeconds: 300 },
  { label: '10 min', inSeconds: 600 },
  { label: '30 min', inSeconds: 1800 },
  { label: 'Full Signal', inSeconds: -1 } // TODO: add useTranslation.ts and use this label from there
];
